import { createReducer } from 'redux-act';
import * as actions from '#app/actions/activePayment';
import type { ActivePaymentFormPayload } from '#app/actions/activePayment';

interface ActivePaymentState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: ActivePaymentState = {
  modalVisible: false,
  form: {},
};

const setActivePaymentModalVisible = (
  state: ActivePaymentState,
  bool: boolean
): ActivePaymentState => ({
  ...state,
  modalVisible: bool,
});

const setActivePaymentForm = (
  state: ActivePaymentState,
  form: ActivePaymentFormPayload
): ActivePaymentState => ({
  ...state,
  form: form ?? {},
});

const closeActivePaymentForm = (state: ActivePaymentState): ActivePaymentState => ({
  ...state,
  form: {},
  modalVisible: false,
});

export default createReducer<ActivePaymentState>(
  {
    [actions.setActivePaymentModalVisible as any]: setActivePaymentModalVisible,
    [actions.setActivePaymentForm as any]: setActivePaymentForm,
    [actions.closeActivePaymentForm as any]: closeActivePaymentForm,
  },
  initialState
);
